/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discount_Rule_AddInputs */

const vi_discount_rule_add = /** @type {(inputs: Discount_Rule_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm quy tắc`)
};

/**

* @param {Discount_Rule_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const discount_rule_add = /** @type {((inputs?: Discount_Rule_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discount_Rule_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_discount_rule_add(inputs)
});